import { render, staticRenderFns } from "./r-tip.vue?vue&type=template&id=2f993b4d"
import script from "./r-tip.vue?vue&type=script&lang=js"
export * from "./r-tip.vue?vue&type=script&lang=js"
import style0 from "./r-tip.vue?vue&type=style&index=0&id=2f993b4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports